import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlogCardGrid from "../../templates/blog-card-grid"
import ExternalLinks from "../../../external-links"
import VariantContainer from "../../atoms/variant-container"
import { css } from "styled-components"

export default function BlogFeatures(props) {
  const query = useStaticQuery(graphql`
    query {
      blogImage1: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/blog/blog image 1.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogImage2: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/blog/blog image 2.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogImage3: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/blog/blog image 3.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const blogCardDetails = [
    {
      fluidImage: query.blogImage1.childImageSharp.fluid,
      title: "Indoor Positioning vs Indoor Navigation",
      description:
        "Learn about these two technologies, how they work, and how to use them in combination to provide the ultimate wayfinding experience.",
      link: ExternalLinks.hubspot.indoorPositioning
        .indoorPositioningVsIndoorNavigation,
    },
    {
      fluidImage: query.blogImage2.childImageSharp.fluid,
      title: "What is Blue Dot Wayfinding?",
      description:
        "What is Blue Dot, what components make up the experience, and what type of accuracy can be expected?",
      link: ExternalLinks.hubspot.indoorPositioning.whatIsBlueDotWayfinding,
    },
    {
      fluidImage: query.blogImage3.childImageSharp.fluid,
      title: "9 Use Cases for Blue Dot Wayfinding",
      description:
        "Outdoor navigation has become a mindless standard in today’s society thanks to blue dot wayfinding...",
      link: ExternalLinks.hubspot.indoorPositioning
        .useCasesForBlueDotWayfinding,
    },
  ]

  return (
    <>
      <VariantContainer
        variants={[
          css`
            grid-column: 1 / -1;
            width: 100%;
            border-bottom: 1px solid #e5e5e5;
          `,
        ]}
      ></VariantContainer>
      <BlogCardGrid
        title="Learn More About Indoor Positioning"
        blogCardDetails={blogCardDetails}
      />
    </>
  )
}
